import { ReactElement } from 'react';
import { Image as MantineImage } from '@mantine/core';

export const Image = (props: any): ReactElement => {
  return <MantineImage {...props} />;
};
